import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=86876c38&scoped=true"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=86876c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86876c38",
  null
  
)

export default component.exports